// extracted by mini-css-extract-plugin
module.exports = {"line-gray":"#e0e0e0","topDivider":"Buy-module__topDivider___2sN2Q"};